export default __webpack_public_path__ + "static/media/landChest1.e8c07647.svg";